import React, {useState} from 'react';
import {connect} from 'react-redux';
import { Form, Input, Button, Alert, Row, Col } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import * as actions from '../store/actions/auth';
import Spinner from '../components/spinner';
import { useTranslation } from "react-i18next";
import validator from 'validator'

const ResetPass = (props) => {
    const { t } = useTranslation();
    const [strongPass, setStrongPass] = useState('')
  const onFinish = values => {
    setStrongPass('');
    if (validator.isStrongPassword(values.password, {
    minLength: 8, minLowercase: 1, minUppercase: 1, minNumbers: 1, minSymbols: 1
    })) {
        props.resetPass(values.password, props.match.params.uid, props.match.params.token);
    } else {
        setStrongPass(<Alert message={t("passStrongMsg")} type="error" showIcon className="with_space" />);
    }
  };

  let errorMessage = null;
    if(props.error){
        if(props.error.error && props.error.error.error){
            errorMessage = (
                <Alert message={t(props.error.error.error)} type="error" showIcon closable className="with_space" />
            )
        }else{
            if(props.error.error && props.error.error.success){
                errorMessage = (
                    <Alert message={t(props.error.error.success)} type="success" showIcon closable className="with_space" />
                )
            }else{
                errorMessage = (
                    <Alert message={t("changePassError")} type="error" showIcon closable className="with_space" />
                )
            }
        }
    }

  return (
      <div>
        { errorMessage}
        {strongPass}
        { props.token ? window.location.replace('/')
        :
            <Spinner spinning={props.loading}>
                <Row className="layout_padding">
                <Col xs={{ span: 0 }} md={{ span: 8 }} lg={{ span: 8 }}></Col>
                <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <h2 className="title">{t("newPassword")}</h2>
                    <Form name="reset_password" className="login-form" onFinish={onFinish}>
                        <Form.Item name="password"
                        rules={[
                            {
                            required: true,
                            message: t("passwordValMsg"),
                            },
                        ]}
                        hasFeedback
                        >
                        <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder={t("password")} />
                        </Form.Item>

                        <Form.Item name="confirm" dependencies={['password']} hasFeedback
                        rules={[
                            {
                            required: true,
                            message: t("confirmPasswordValMsg"),
                            },
                            ({ getFieldValue }) => ({
                            validator(rule, value) {
                                if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                                }
                                return Promise.reject(t("passNoMatch"));
                            },
                            }),
                        ]}
                        >
                        <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder={t("confirmPassword")} />
                        </Form.Item>

                        <Form.Item className="text_center">
                            <Button type="primary" htmlType="submit" className="login-form-button">
                            {t("change")}
                            </Button>  
                        </Form.Item>
                    </Form>
                </Col>
                <Col xs={{ span: 0 }} md={{ span: 8 }} lg={{ span: 8 }}></Col>
              </Row>
            </Spinner>
        } 
        </div>
  );
};

const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        error: state.error,
        token: state.token,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        resetPass: (password, uid, token) => dispatch(actions.resetPassword(password, uid, token))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPass);